import React, { useEffect, useState, useRef, useCallback } from "react";
import { Rnd } from "react-rnd";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { useLocation } from 'react-router-dom';
import socket from "../socket";


export default function Tables() {
  const navigate = useNavigate();
  const [tables, setTables] = useState([]);
  const [ordersMap, setOrdersMap] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [showBillModal, setShowBillModal] = useState(false);
  const [billData, setBillData] = useState(null);
  const saveTimer = useRef(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isWaiterMode = searchParams.get('waiter') === 'true';
  

  // Detect mobile (disable drag on mobile)
  const isTouchDevice =
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);

  // Track drag distance (to prevent accidental open)
  const dragStartPos = useRef({ x: 0, y: 0 });
  const dragged = useRef(false);

  
useEffect(() => {
  socket.on("tableUpdated", ({ tableId, status, orderCount }) => {
    console.log("📥 Real-time update received:", tableId);

    setTables(prev =>
      prev.map(t => String(t._id) === String(tableId)
        ? { ...t, status }
        : t
      )
    );

    setOrdersMap(prev => ({
      ...prev,
      [tableId]: orderCount
    }));
  });

  return () => {
    socket.off("tableUpdated");
  };
}, []);



  useEffect(() => {
    load();

    // If navigated with reload flag, reload tables
    if (location.state?.reload) {
      load();
      // Clear the state to prevent infinite reloads
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // ✅ Load tables
  const load = useCallback(async () => {
    try {
      const res = await api.get("/tables");
      const tableData = res.data;
      setTables(tableData);

      // const map = {};
      // for (const t of tableData) {
      //   const o = await api.get(`/tables/${t._id}/orders`);
      //   map[t._id] = o.data.length;
      // }
      // setOrdersMap(map);
      // Fetch all order counts in parallel
      const map = await Promise.all(
        tableData.map(async t => {
          const o = await api.get(`/tables/${t._id}/orders`);
          return [String(t._id), o.data.length];
        })
      );
setOrdersMap(Object.fromEntries(map));

    } catch (e) {
      console.error("Load error:", e);
    }
  }, []);

  // ✅ Initial load + socket listener
//   useEffect(() => {
//   // load tables initially
//   load();

//   // Connect socket (⚠️ use your system's local IP, not localhost)
//   const socket = io("http://192.168.1.10:5000", {
//     transports: ["websocket"], // ensures fast connection
//   });

//   socket.on("connect", () => console.log("🟢 Connected to socket"));
//   socket.on("disconnect", () => console.log("🔴 Disconnected from socket"));
// //   socket.on("tableUpdated", (data) => {
// //   // data = { tableId, status, orderCount }
// //   setTables(prev => prev.map(t => t._id === data.tableId ? { ...t, status: data.status } : t));
// //   setOrdersMap(prev => ({ ...prev, [data.tableId]: data.orderCount }));
// // });


//   return () => {
//     socket.disconnect();
//   };
// }, []);

// useEffect(() => {
//   const socket = io("http://192.168.1.10:8080", {
//     transports: ["websocket"],
//   });

//   socket.on("connect", () => console.log("🟢 Socket connected"));

//   socket.on("tableUpdated", ({ tableId, status, orderCount }) => {
//   console.log("📥 Real-time update received:", tableId);

//   setTables(prev =>
//     prev.map(t =>
//       String(t._id) === String(tableId)
//         ? { ...t, status }
//         : t
//     )
//   );

//   setOrdersMap(prev => ({
//     ...prev,
//     [tableId]: orderCount
//   }));
// });


//   return () => socket.disconnect();
// }, []);



  // ✅ Add new table
  async function addTable() {
    await api.post("/tables", { name: "Table " + (tables.length + 1) });
    await load();
  }

  // ✅ Save layout (drag/resize)
  // function saveLayoutDebounced(id, data) {
  //   if (saveTimer.current) clearTimeout(saveTimer.current);
  //   saveTimer.current = setTimeout(async () => {
  //     try {
  //       await api.put(`/tables/${id}`, data);
  //     } catch (err) {
  //       console.error("Layout save error:", err);
  //     }
  //   }, 400);
  // }

  const layoutChanges = useRef({});

function saveLayoutDebounced(id, data) {
  layoutChanges.current[id] = data;
  if (saveTimer.current) clearTimeout(saveTimer.current);
  saveTimer.current = setTimeout(async () => {
    await Promise.all(Object.entries(layoutChanges.current).map(([id, d]) =>
      api.put(`/tables/${id}`, d)
    ));
    layoutChanges.current = {};
  }, 500);
}


  function updateLocalPosition(id, x, y) {
    setTables((prev) => prev.map((t) => (String(t._id) === String(id)
 ? { ...t, x, y } : t)));
  }

  function updateLocalSize(id, width, height, x, y) {
    setTables((prev) =>
      prev.map((t) =>
        String(t._id) === String(id)
 ? { ...t, width, height, x, y } : t
      )
    );
  }

  // ✅ Bill Generation
  async function generateBill(table) {
    try {
      const res = await api.post(`/tables/${table._id}/bill`);
      const bill = res.data;
      const orders = await api.get(`/tables/${table._id}/orders`);

      const items = orders.data.flatMap((o) =>
        o.items.map((i) => ({
          name: i.item?.name || "Item",
          qty: i.qty,
          price: i.item?.price || 0,
          total: (i.item?.price || 0) * i.qty,
        }))
      );

      setBillData({
        _id: bill._id,
        table: table.name,
        items,
        total: items.reduce((s, i) => s + i.total, 0),
      });
      setShowBillModal(true);
      await load();
    } catch (e) {
      console.error("Bill error:", e);
    }
  }

  // ✅ Download Bill PDF
  async function downloadBill(id) {
    try {
      const pdfRes = await fetch(`http://localhost:5000/api/bills/${id}/pdf`);
      const blob = await pdfRes.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `bill_${id}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Download error:", e);
    }
  }

  // ✅ Confirm dialog
  function openConfirm(action) {
    setConfirmAction(() => action);
    setShowConfirm(true);
  }

  

  // ✅ Table color logic
  const getColor = (status) => {
    switch (status) {
      case "free":
        return "bg-green-200";
      case "occupied":
        return "bg-orange-200";
      case "billed":
        return "bg-blue-200";
      default:
        return "bg-gray-200";
    }
  };

  // ✅ Print Bill
  function handlePrint() {
    const html = document.getElementById("bill-preview").innerHTML;
    const w = window.open("", "", "width=800,height=600");
    w.document.write(`
      <html><head><title>S N HOTEL BILL</title>
      <style>
        body { font-family: Arial; padding: 20px; color: #000; }
        h2 { text-align: center; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        th, td { border: 1px solid #999; padding: 6px; text-align: right; }
        th:first-child, td:first-child { text-align: left; }
        tfoot td { font-weight: bold; }
      </style>
      </head><body>
      <h2>S N HOTEL</h2>
      ${html}
      </body></html>
    `);
    w.document.close();
    w.print();
  }

  return (
    <div className="relative w-full h-[120vh] bg-gray-100 overflow-auto rounded-lg shadow-inner">
      <div className="absolute top-2 left-2 z-10">
        {!isWaiterMode && (
        <button
          className="bg-green-600 text-white px-3 py-1 rounded"
          onClick={addTable}
        >
          + Add Table
        </button>
      )}
      </div>

      {tables.map((t) => (
        <Rnd
  key={t._id}
  size={{ width: t.width || 120, height: t.height || 80 }}
  position={{ x: t.x || 0, y: t.y || 0 }}
  bounds="parent"
  enableResizing={!isTouchDevice}
  disableDragging={isTouchDevice} // 🚫 no drag on mobile
  dragGrid={[2, 2]}
  cancel=".no-drag"
  onMouseDown={() => {
    // reset flag when mouse is pressed
    dragged.current = false;
  }}
  onDragStart={() => {
    dragged.current = true;
  }}
  onDragStop={(e, d) => {
    updateLocalPosition(t._id, d.x, d.y);
    saveLayoutDebounced(t._id, { x: d.x, y: d.y });
    // small delay before allowing clicks again
    setTimeout(() => {
      dragged.current = false;
    }, 100);
  }}
  onResizeStop={(e, dir, ref, delta, pos) => {
    const w = parseInt(ref.style.width);
    const h = parseInt(ref.style.height);
    updateLocalSize(t._id, w, h, pos.x, pos.y);
    saveLayoutDebounced(t._id, { width: w, height: h, x: pos.x, y: pos.y });
    setTimeout(() => {
      dragged.current = false;
    }, 100);
  }}
  className={`relative ${getColor(
    t.status
  )} rounded shadow-md transition hover:shadow-lg select-none flex flex-col justify-between items-center cursor-pointer`}
  // onClick={() => {
  //   // ✅ open table only if NOT dragging
  //   if (!dragged.current) {
  //     navigate(`/tables/${t._id}`);
  //   }
  // }}
  onClick={() => {
  if (!dragged.current) {
    if (isWaiterMode) {
      navigate(`/waiter/table/${t._id}`);
    } else {
      navigate(`/tables/${t._id}`);
    }
  }
}}


>
  {/* Content */}
  <div className="flex flex-col items-center justify-center flex-grow text-center px-2 pt-2">
    <div className="font-bold text-sm">{t.name}</div>
    <div className="text-xs capitalize mt-0.5">{t.status}</div>
    <div className="text-xs mt-0.5">
      {ordersMap[String(t._id)] > 0
  ? `${ordersMap[String(t._id)]} order(s)`
  : "No orders"}

    </div>
  </div>

  {/* Buttons */}
  <div className="flex justify-center gap-2 w-full pb-2 mt-auto z-10 no-drag">
    {ordersMap[String(t._id)] > 0 && (
      <button
        className="bg-yellow-500 text-white text-xs font-medium rounded transition px-[6%] py-[2px]"
        onClick={(e) => {
          e.stopPropagation();
          generateBill(t);
        }}
      >
        Bill
      </button>
    )}
    {(t.status === "occupied" || t.status === "billed") && (
      <button
        className="bg-red-500 text-white text-xs font-medium rounded transition px-[6%] py-[2px]"
        onClick={(e) => {
          e.stopPropagation();
          // openConfirm(async () => {
          //   await api.delete(`/tables/${t._id}/orders/all`);
          //   await api.put(`/tables/${t._id}/free`);
          //   await load();
          // });
          openConfirm(async () => {
          // Optimistic UI update
          setTables(prev => prev.map(tbl => tbl._id === t._id ? { ...tbl, status: 'free' } : tbl));
          setOrdersMap(prev => ({ ...prev, [t._id]: 0 }));

          // Call API
          await api.delete(`/tables/${t._id}/orders/all`);
          await api.put(`/tables/${t._id}/free`);
        });


        }}
      >
        Free
      </button>
    )}
  </div>
</Rnd>







      ))}

      {/* Confirmation Modal */}
      {showConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-5 w-80 text-center">
            <h3 className="text-lg font-semibold mb-3">Are you sure?</h3>
            <div className="flex justify-center gap-4">
              <button
                className="bg-red-500 text-white px-4 py-1 rounded"
                onClick={() => {
                  confirmAction && confirmAction();
                  setShowConfirm(false);
                }}
              >
                Yes
              </button>
              <button
                className="bg-gray-300 px-4 py-1 rounded"
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bill Modal */}
      {showBillModal && billData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[500px]">
            <h3 className="text-xl font-semibold mb-4 text-center">
              Bill Preview
            </h3>
            <div id="bill-preview">
              <p className="font-bold mb-2">Table: {billData.table}</p>
              <table className="w-full text-sm border">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border p-1 text-left">Item</th>
                    <th className="border p-1 text-right">Qty</th>
                    <th className="border p-1 text-right">Price</th>
                    <th className="border p-1 text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {billData.items.map((i, idx) => (
                    <tr key={idx}>
                      <td className="border p-1">{i.name}</td>
                      <td className="border p-1 text-right">{i.qty}</td>
                      <td className="border p-1 text-right">₹{i.price}</td>
                      <td className="border p-1 text-right">₹{i.total}</td>
                    </tr>
                  ))}
                  <tr className="font-semibold bg-gray-100">
                    <td colSpan="3" className="border p-1 text-right">
                      Grand Total
                    </td>
                    <td className="border p-1 text-right">₹{billData.total}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mt-5 flex justify-center gap-4">
              <button
                className="bg-blue-600 text-white px-4 py-1 rounded"
                onClick={handlePrint}
              >
                Print
              </button>
              <button
                className="bg-green-600 text-white px-4 py-1 rounded"
                onClick={() => downloadBill(billData._id)}
              >
                Download
              </button>
              <button
                className="bg-gray-400 text-white px-4 py-1 rounded"
                onClick={() => setShowBillModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { Rnd } from "react-rnd";
// import { useNavigate, useLocation } from "react-router-dom";
// import { io } from "socket.io-client";
// import api from "../api";

// export default function Tables() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [tables, setTables] = useState([]);
//   const [ordersMap, setOrdersMap] = useState({});
//   const [showConfirm, setShowConfirm] = useState(false);
//   const [confirmAction, setConfirmAction] = useState(null);
//   const [showBillModal, setShowBillModal] = useState(false);
//   const [billData, setBillData] = useState(null);

//   const saveTimer = useRef(null);
//   const layoutChanges = useRef({});
//   const dragged = useRef(false);

//   const isTouchDevice =
//     typeof window !== "undefined" &&
//     ("ontouchstart" in window || navigator.maxTouchPoints > 0);

//   /** ---------- LOAD TABLES & ORDERS ---------- */
//   const load = useCallback(async () => {
//     try {
//       const res = await api.get("/tables");
//       const tableData = res.data;
//       setTables(tableData);

//       // Fetch order counts in parallel
//       const counts = await Promise.all(
//         tableData.map(async t => {
//           const o = await api.get(`/tables/${t._id}/orders`);
//           return [t._id, o.data.length];
//         })
//       );
//       setOrdersMap(Object.fromEntries(counts));
//     } catch (e) {
//       console.error("Load error:", e);
//     }
//   }, []);

//   useEffect(() => {
//     load();
//     if (location.state?.reload) {
//       load();
//       window.history.replaceState({}, document.title);
//     }
//   }, [location.state, load]);

//   /** ---------- SOCKET CONNECTION ---------- */
//   useEffect(() => {
//     const socket = io("http://192.168.1.10:5000", { transports: ["websocket"] });

//     socket.on("connect", () => console.log("🟢 Connected to socket"));
//     socket.on("disconnect", () => console.log("🔴 Disconnected from socket"));
//     socket.on("tableUpdated", ({ tableId, status, orderCount }) => {
//       setTables(prev =>
//         prev.map(t => (t._id === tableId ? { ...t, status } : t))
//       );
//       setOrdersMap(prev => ({ ...prev, [tableId]: orderCount }));
//     });

//     return () => socket.disconnect();
//   }, []);

//   /** ---------- ADD TABLE ---------- */
//   const addTable = async () => {
//     await api.post("/tables", { name: `Table ${tables.length + 1}` });
//     await load();
//   };

//   /** ---------- DEBOUNCED LAYOUT SAVE ---------- */
//   const saveLayoutDebounced = (id, data) => {
//     layoutChanges.current[id] = data;
//     if (saveTimer.current) clearTimeout(saveTimer.current);
//     saveTimer.current = setTimeout(async () => {
//       await Promise.all(
//         Object.entries(layoutChanges.current).map(([id, d]) =>
//           api.put(`/tables/${id}`, d)
//         )
//       );
//       layoutChanges.current = {};
//     }, 500);
//   };

//   const updateLocalPosition = (id, x, y) =>
//     setTables(prev => prev.map(t => (t._id === id ? { ...t, x, y } : t)));

//   const updateLocalSize = (id, width, height, x, y) =>
//     setTables(prev =>
//       prev.map(t =>
//         t._id === id ? { ...t, width, height, x, y } : t
//       )
//     );

//   /** ---------- BILL GENERATION ---------- */
//   const generateBill = async (table) => {
//     try {
//       const bill = (await api.post(`/tables/${table._id}/bill`)).data;
//       const orders = (await api.get(`/tables/${table._id}/orders`)).data;

//       const items = orders.flatMap(o =>
//         o.items.map(i => ({
//           name: i.item?.name || "Item",
//           qty: i.qty,
//           price: i.item?.price || 0,
//           total: (i.item?.price || 0) * i.qty,
//         }))
//       );

//       setBillData({
//         _id: bill._id,
//         table: table.name,
//         items,
//         total: items.reduce((s, i) => s + i.total, 0),
//       });
//       setShowBillModal(true);
//       await load();
//     } catch (e) {
//       console.error("Bill error:", e);
//     }
//   };

//   const downloadBill = async (id) => {
//     try {
//       const res = await fetch(`http://localhost:5000/api/bills/${id}/pdf`);
//       const blob = await res.blob();
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `bill_${id}.pdf`;
//       a.click();
//       URL.revokeObjectURL(url);
//     } catch (e) {
//       console.error("Download error:", e);
//     }
//   };

//   const handlePrint = () => {
//     const html = document.getElementById("bill-preview").innerHTML;
//     const w = window.open("", "", "width=800,height=600");
//     w.document.write(`
//       <html><head><title>Bill</title>
//       <style>
//         body{font-family:Arial;padding:20px;color:#000;}
//         h2{text-align:center;margin-bottom:20px;}
//         table{width:100%;border-collapse:collapse;margin-top:10px;}
//         th, td{border:1px solid #999;padding:6px;text-align:right;}
//         th:first-child, td:first-child{text-align:left;}
//         tfoot td{font-weight:bold;}
//       </style>
//       </head><body>
//       <h2>S N HOTEL</h2>
//       ${html}
//       </body></html>
//     `);
//     w.document.close();
//     w.print();
//   };

//   /** ---------- CONFIRM DIALOG ---------- */
//   const openConfirm = (action) => {
//     setConfirmAction(() => action);
//     setShowConfirm(true);
//   };

//   /** ---------- TABLE COLOR ---------- */
//   const getColor = (status) => {
//     switch (status) {
//       case "free": return "bg-green-200";
//       case "occupied": return "bg-orange-200";
//       case "billed": return "bg-blue-200";
//       default: return "bg-gray-200";
//     }
//   };

//   return (
//     <div className="relative w-full h-[120vh] bg-gray-100 overflow-auto rounded-lg shadow-inner p-2">
//       <button className="bg-green-600 text-white px-3 py-1 rounded mb-2" onClick={addTable}>
//         + Add Table
//       </button>

//       {tables.map((t) => (
//         <Rnd
//           key={t._id}
//           size={{ width: t.width || 120, height: t.height || 80 }}
//           position={{ x: t.x || 0, y: t.y || 0 }}
//           bounds="parent"
//           enableResizing={!isTouchDevice}
//           disableDragging={isTouchDevice}
//           dragGrid={[2, 2]}
//           cancel=".no-drag"
//           onMouseDown={() => (dragged.current = false)}
//           onDragStart={() => (dragged.current = true)}
//           onDragStop={(e, d) => {
//             updateLocalPosition(t._id, d.x, d.y);
//             saveLayoutDebounced(t._id, { x: d.x, y: d.y });
//             setTimeout(() => (dragged.current = false), 100);
//           }}
//           onResizeStop={(e, dir, ref, delta, pos) => {
//             const w = parseInt(ref.style.width);
//             const h = parseInt(ref.style.height);
//             updateLocalSize(t._id, w, h, pos.x, pos.y);
//             saveLayoutDebounced(t._id, { width: w, height: h, x: pos.x, y: pos.y });
//             setTimeout(() => (dragged.current = false), 100);
//           }}
//           className={`relative ${getColor(t.status)} rounded shadow-md transition hover:shadow-lg select-none flex flex-col justify-between items-center cursor-pointer`}
//           onClick={() => !dragged.current && navigate(`/tables/${t._id}`)}
//         >
//           <div className="flex flex-col items-center justify-center flex-grow text-center px-2 pt-2">
//             <div className="font-bold text-sm">{t.name}</div>
//             <div className="text-xs capitalize mt-0.5">{t.status}</div>
//             <div className="text-xs mt-0.5">
//               {ordersMap[t._id] > 0 ? `${ordersMap[t._id]} order(s)` : "No orders"}
//             </div>
//           </div>

//           <div className="flex justify-center gap-2 w-full pb-2 mt-auto z-10 no-drag">
//             {ordersMap[t._id] > 0 && (
//               <button className="bg-yellow-500 text-white text-xs rounded px-[6%] py-[2px]" onClick={(e) => { e.stopPropagation(); generateBill(t); }}>
//                 Bill
//               </button>
//             )}
//             {(t.status === "occupied" || t.status === "billed") && (
//               <button className="bg-red-500 text-white text-xs rounded px-[6%] py-[2px]" onClick={(e) => {
//                 e.stopPropagation();
//                 openConfirm(async () => {
//                   setTables(prev => prev.map(tbl => tbl._id === t._id ? { ...tbl, status: 'free' } : tbl));
//                   setOrdersMap(prev => ({ ...prev, [t._id]: 0 }));
//                   await api.delete(`/tables/${t._id}/orders/all`);
//                   await api.put(`/tables/${t._id}/free`);
//                 });
//               }}>
//                 Free
//               </button>
//             )}
//           </div>
//         </Rnd>
//       ))}

//       {/* Confirmation Modal */}
//       {showConfirm && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-5 w-80 text-center">
//             <h3 className="text-lg font-semibold mb-3">Are you sure?</h3>
//             <div className="flex justify-center gap-4">
//               <button className="bg-red-500 text-white px-4 py-1 rounded" onClick={() => { confirmAction?.(); setShowConfirm(false); }}>
//                 Yes
//               </button>
//               <button className="bg-gray-300 px-4 py-1 rounded" onClick={() => setShowConfirm(false)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Bill Modal */}
//       {showBillModal && billData && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg shadow-lg p-6 w-[500px]">
//             <h3 className="text-xl font-semibold mb-4 text-center">Bill Preview</h3>
//             <div id="bill-preview">
//               <p className="font-bold mb-2">Table: {billData.table}</p>
//               <table className="w-full text-sm border">
//                 <thead>
//                   <tr className="bg-gray-100">
//                     <th className="border p-1 text-left">Item</th>
//                     <th className="border p-1 text-right">Qty</th>
//                     <th className="border p-1 text-right">Price</th>
//                     <th className="border p-1 text-right">Total</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {billData.items.map((i, idx) => (
//                     <tr key={idx}>
//                       <td className="border p-1">{i.name}</td>
//                       <td className="border p-1 text-right">{i.qty}</td>
//                       <td className="border p-1 text-right">₹{i.price}</td>
//                       <td className="border p-1 text-right">₹{i.total}</td>
//                     </tr>
//                   ))}
//                   <tr className="font-semibold bg-gray-100">
//                     <td colSpan="3" className="border p-1 text-right">Grand Total</td>
//                     <td className="border p-1 text-right">₹{billData.total}</td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//             <div className="mt-5 flex justify-center gap-4">
//               <button className="bg-blue-600 text-white px-4 py-1 rounded" onClick={handlePrint}>Print</button>
//               <button className="bg-green-600 text-white px-4 py-1 rounded" onClick={() => downloadBill(billData._id)}>Download</button>
//               <button className="bg-gray-400 text-white px-4 py-1 rounded" onClick={() => setShowBillModal(false)}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { Rnd } from "react-rnd";
// import { useNavigate, useLocation } from "react-router-dom";
// import { io } from "socket.io-client";
// import api from "../api";

// // Reusable Modal Component
// function Modal({ children, onClose }) {
//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg shadow-lg p-6 w-[500px] relative">
//         <button
//           className="absolute top-2 right-2 text-gray-600 font-bold"
//           onClick={onClose}
//         >
//           ×
//         </button>
//         {children}
//       </div>
//     </div>
//   );
// }

// export default function Tables() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [tables, setTables] = useState([]);
//   const [ordersMap, setOrdersMap] = useState({});
//   const [showConfirm, setShowConfirm] = useState(false);
//   const [confirmAction, setConfirmAction] = useState(null);
//   const [showBillModal, setShowBillModal] = useState(false);
//   const [billData, setBillData] = useState(null);
//   const [editingNameId, setEditingNameId] = useState(null);
//   const [editingName, setEditingName] = useState("");

//   const saveTimer = useRef(null);
//   const layoutChanges = useRef({});
//   const dragged = useRef(false);

//   const isTouchDevice =
//     typeof window !== "undefined" &&
//     ("ontouchstart" in window || navigator.maxTouchPoints > 0);

//   /** ---------- LOAD TABLES & ORDERS ---------- */
//   const load = useCallback(async () => {
//     try {
//       const res = await api.get("/tables");
//       const tableData = res.data;
//       setTables(tableData);

//       const counts = await Promise.all(
//         tableData.map(async t => {
//           const o = await api.get(`/tables/${t._id}/orders`);
//           return [t._id, o.data.length];
//         })
//       );
//       setOrdersMap(Object.fromEntries(counts));
//     } catch (e) {
//       console.error("Load error:", e);
//     }
//   }, []);

//   useEffect(() => {
//     load();
//     if (location.state?.reload) {
//       load();
//       window.history.replaceState({}, document.title);
//     }
//   }, [location.state, load]);

//   /** ---------- SOCKET CONNECTION ---------- */
//   useEffect(() => {
//     const socket = io("http://192.168.1.10:5000", { transports: ["websocket"] });

//     socket.on("connect", () => console.log("🟢 Connected to socket"));
//     socket.on("disconnect", () => console.log("🔴 Disconnected from socket"));
//     socket.on("tableUpdated", ({ tableId, status, orderCount, name }) => {
//       setTables(prev =>
//         prev.map(t =>
//           t._id === tableId ? { ...t, status, name: name || t.name } : t
//         )
//       );
//       setOrdersMap(prev => ({ ...prev, [tableId]: orderCount }));
//     });

//     return () => socket.disconnect();
//   }, []);

//   /** ---------- ADD TABLE ---------- */
//   const addTable = async () => {
//     await api.post("/tables", { name: `Table ${tables.length + 1}` });
//     await load();
//   };

//   /** ---------- DEBOUNCED LAYOUT SAVE ---------- */
//   const saveLayoutDebounced = (id, data) => {
//     layoutChanges.current[id] = data;
//     if (saveTimer.current) clearTimeout(saveTimer.current);
//     saveTimer.current = setTimeout(async () => {
//       await Promise.all(
//         Object.entries(layoutChanges.current).map(([id, d]) =>
//           api.put(`/tables/${id}`, d)
//         )
//       );
//       layoutChanges.current = {};
//     }, 500);
//   };

//   const updateLocalPosition = (id, x, y) =>
//     setTables(prev => prev.map(t => (t._id === id ? { ...t, x, y } : t)));

//   const updateLocalSize = (id, width, height, x, y) =>
//     setTables(prev =>
//       prev.map(t =>
//         t._id === id ? { ...t, width, height, x, y } : t
//       )
//     );

//   /** ---------- INLINE EDIT TABLE NAME ---------- */
//   const startEditName = (id, currentName) => {
//     setEditingNameId(id);
//     setEditingName(currentName);
//   };

//   const saveName = async (id) => {
//     await api.put(`/tables/${id}`, { name: editingName });
//     setTables(prev =>
//       prev.map(t => (t._id === id ? { ...t, name: editingName } : t))
//     );
//     setEditingNameId(null);
//     setEditingName("");
//   };

//   /** ---------- BILL GENERATION ---------- */
//   const generateBill = async (table) => {
//     try {
//       const bill = (await api.post(`/tables/${table._id}/bill`)).data;
//       const orders = (await api.get(`/tables/${table._id}/orders`)).data;

//       const items = orders.flatMap(o =>
//         o.items.map(i => ({
//           name: i.item?.name || "Item",
//           qty: i.qty,
//           price: i.item?.price || 0,
//           total: (i.item?.price || 0) * i.qty,
//         }))
//       );

//       setBillData({
//         _id: bill._id,
//         table: table.name,
//         items,
//         total: items.reduce((s, i) => s + i.total, 0),
//       });
//       setShowBillModal(true);
//       await load();
//     } catch (e) {
//       console.error("Bill error:", e);
//     }
//   };

//   const downloadBill = async (id) => {
//     try {
//       const res = await fetch(`http://localhost:5000/api/bills/${id}/pdf`);
//       const blob = await res.blob();
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `bill_${id}.pdf`;
//       a.click();
//       URL.revokeObjectURL(url);
//     } catch (e) {
//       console.error("Download error:", e);
//     }
//   };

//   const handlePrint = () => {
//     const html = document.getElementById("bill-preview").innerHTML;
//     const w = window.open("", "", "width=800,height=600");
//     w.document.write(`<html><head><title>Bill</title><style>
//       body{font-family:Arial;padding:20px;color:#000;}
//       h2{text-align:center;margin-bottom:20px;}
//       table{width:100%;border-collapse:collapse;margin-top:10px;}
//       th, td{border:1px solid #999;padding:6px;text-align:right;}
//       th:first-child, td:first-child{text-align:left;}
//       tfoot td{font-weight:bold;}
//     </style></head><body><h2>S N HOTEL</h2>${html}</body></html>`);
//     w.document.close();
//     w.print();
//   };

//   /** ---------- CONFIRM DIALOG ---------- */
//   const openConfirm = (action) => {
//     setConfirmAction(() => action);
//     setShowConfirm(true);
//   };

//   const getColor = (status) => {
//     switch (status) {
//       case "free": return "bg-green-200";
//       case "occupied": return "bg-orange-200";
//       case "billed": return "bg-blue-200";
//       default: return "bg-gray-200";
//     }
//   };

//   return (
//     <div className="relative w-full h-[120vh] bg-gray-100 overflow-auto rounded-lg shadow-inner p-2">
//       <button className="bg-green-600 text-white px-3 py-1 rounded mb-2" onClick={addTable}>
//         + Add Table
//       </button>

//       {tables.map((t) => (
//         <Rnd
//           key={t._id}
//           size={{ width: t.width || 120, height: t.height || 80 }}
//           position={{ x: t.x || 0, y: t.y || 0 }}
//           bounds="parent"
//           enableResizing={!isTouchDevice}
//           disableDragging={isTouchDevice}
//           dragGrid={[2, 2]}
//           cancel=".no-drag"
//           onMouseDown={() => (dragged.current = false)}
//           onDragStart={() => (dragged.current = true)}
//           onDragStop={(e, d) => {
//             updateLocalPosition(t._id, d.x, d.y);
//             saveLayoutDebounced(t._id, { x: d.x, y: d.y });
//             setTimeout(() => (dragged.current = false), 100);
//           }}
//           onResizeStop={(e, dir, ref, delta, pos) => {
//             const w = parseInt(ref.style.width);
//             const h = parseInt(ref.style.height);
//             updateLocalSize(t._id, w, h, pos.x, pos.y);
//             saveLayoutDebounced(t._id, { width: w, height: h, x: pos.x, y: pos.y });
//             setTimeout(() => (dragged.current = false), 100);
//           }}
//           className={`relative ${getColor(t.status)} rounded shadow-md transition hover:shadow-lg select-none flex flex-col justify-between items-center cursor-pointer`}
//           onClick={() => !dragged.current && navigate(`/tables/${t._id}`)}
//         >
//           <div className="flex flex-col items-center justify-center flex-grow text-center px-2 pt-2">
//             {editingNameId === t._id ? (
//               <input
//                 value={editingName}
//                 onChange={e => setEditingName(e.target.value)}
//                 onBlur={() => saveName(t._id)}
//                 onKeyDown={e => e.key === "Enter" && saveName(t._id)}
//                 className="border px-1 rounded text-sm w-full text-center"
//                 autoFocus
//               />
//             ) : (
//               <div
//                 className="font-bold text-sm cursor-pointer"
//                 onClick={(e) => { e.stopPropagation(); startEditName(t._id, t.name); }}
//               >
//                 {t.name}
//               </div>
//             )}
//             <div className="text-xs capitalize mt-0.5">{t.status}</div>
//             <div className="text-xs mt-0.5">
//               {ordersMap[t._id] > 0 ? `${ordersMap[t._id]} order(s)` : "No orders"}
//             </div>
//           </div>

//           <div className="flex justify-center gap-2 w-full pb-2 mt-auto z-10 no-drag">
//             {ordersMap[t._id] > 0 && (
//               <button
//                 className="bg-yellow-500 text-white text-xs rounded px-[6%] py-[2px]"
//                 onClick={(e) => { e.stopPropagation(); generateBill(t); }}
//               >
//                 Bill
//               </button>
//             )}
//             {(t.status === "occupied" || t.status === "billed") && (
//               <button
//                 className="bg-red-500 text-white text-xs rounded px-[6%] py-[2px]"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   openConfirm(async () => {
//                     setTables(prev => prev.map(tbl => tbl._id === t._id ? { ...tbl, status: 'free' } : tbl));
//                     setOrdersMap(prev => ({ ...prev, [t._id]: 0 }));
//                     await api.delete(`/tables/${t._id}/orders/all`);
//                     await api.put(`/tables/${t._id}/free`);
//                   });
//                 }}
//               >
//                 Free
//               </button>
//             )}
//           </div>
//         </Rnd>
//       ))}

//       {/* Confirm Modal */}
//       {showConfirm && (
//         <Modal onClose={() => setShowConfirm(false)}>
//           <h3 className="text-lg font-semibold mb-3">Are you sure?</h3>
//           <div className="flex justify-center gap-4">
//             <button className="bg-red-500 text-white px-4 py-1 rounded" onClick={() => { confirmAction?.(); setShowConfirm(false); }}>
//               Yes
//             </button>
//             <button className="bg-gray-300 px-4 py-1 rounded" onClick={() => setShowConfirm(false)}>
//               Cancel
//             </button>
//           </div>
//         </Modal>
//       )}

//       {/* Bill Modal */}
//       {showBillModal && billData && (
//         <Modal onClose={() => setShowBillModal(false)}>
//           <h3 className="text-xl font-semibold mb-4 text-center">Bill Preview</h3>
//           <div id="bill-preview">
//             <p className="font-bold mb-2">Table: {billData.table}</p>
//             <table className="w-full text-sm border">
//               <thead>
//                 <tr className="bg-gray-100">
//                   <th className="border p-1 text-left">Item</th>
//                   <th className="border p-1 text-right">Qty</th>
//                   <th className="border p-1 text-right">Price</th>
//                   <th className="border p-1 text-right">Total</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {billData.items.map((i, idx) => (
//                   <tr key={idx}>
//                     <td className="border p-1">{i.name}</td>
//                     <td className="border p-1 text-right">{i.qty}</td>
//                     <td className="border p-1 text-right">₹{i.price}</td>
//                     <td className="border p-1 text-right">₹{i.total}</td>
//                   </tr>
//                 ))}
//                 <tr className="font-semibold bg-gray-100">
//                   <td colSpan="3" className="border p-1 text-right">Grand Total</td>
//                   <td className="border p-1 text-right">₹{billData.total}</td>
//                 </tr>
//               </tbody>
//             </table>
//             <div className="mt-5 flex justify-center gap-4">
//               <button className="bg-blue-600 text-white px-4 py-1 rounded" onClick={handlePrint}>Print</button>
//               <button className="bg-green-600 text-white px-4 py-1 rounded" onClick={() => downloadBill(billData._id)}>Download</button>
//             </div>
//           </div>
//         </Modal>
//       )}
//     </div>
//   );
// }
